export const SUPPORTED_LANGS = ['en', 'fr'] as const;
export type SupportedLang = typeof SUPPORTED_LANGS[number];

export const LANG_STORAGE_KEY = 'i18nextLng';

export const sanitizeLanguage = (lang: string | null | undefined): SupportedLang => {
  const normalized = lang?.toLowerCase();
  if (normalized && SUPPORTED_LANGS.includes(normalized as SupportedLang)) return normalized as SupportedLang;
  return 'en';
};

export const setStoredLanguage = (lang: SupportedLang): void => {
  localStorage.setItem(LANG_STORAGE_KEY, lang);
};
